import { render, staticRenderFns } from "./alipayAuthorize2.vue?vue&type=template&id=54cde9ec&scoped=true"
import script from "./alipayAuthorize2.vue?vue&type=script&lang=js"
export * from "./alipayAuthorize2.vue?vue&type=script&lang=js"
import style0 from "./alipayAuthorize2.vue?vue&type=style&index=0&id=54cde9ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cde9ec",
  null
  
)

export default component.exports